import { api } from "@/lib/api";

// ---- Phase 13: republish / unpublish / audit ----

export const republishCourse = (courseId) =>
  api.post(`/courses/${courseId}/republish`).then((r) => r.data);

export const unpublishCourse = (courseId) =>
  api.post(`/courses/${courseId}/unpublish`).then((r) => r.data);

export const adminFetchCourseAudit = (courseId) =>
  api.get(`/admin/courses/${courseId}/audit`).then((r) => r.data);
